import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { FgiBackEndService } from 'src/app/shared/fgi-back-end.service';
import { EstadoCobranca } from 'src/app/model/dominio-cobranca.model';
import { Cobranca } from 'src/app/model/cobranca.model';
import { blockUi, useCache } from "@bndes/bndes-ux4/bndes-angular-utils";
import { HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CobrancaService extends FgiBackEndService<Cobranca> {

  // @Override
  getNewEntity() {
    // o servico sera apenas para leitura
    return undefined;
  }

  // @Override
  protected getResourceURL(): string {
    return undefined;
  }

  getEstados() {
    return this.http.get(`rest/front/cobrancas/estados`, useCache()).pipe(
      catchError((e) => this.handleError(e))) as Observable<Array<EstadoCobranca>>;
  }

  getBoleto(id) {
    return this.http.get('rest/front/cobrancas/' + id + '/boleto-pdf', { responseType: 'blob' }).pipe(
      catchError((e) => this.handleError(e))) as Observable<any>;
  }

   getAnexo(id) {
    return this.http.get('rest/front/cobrancas/' + id + '/anexo-txt', { responseType: 'blob' }).pipe(
      catchError((e) => this.handleError(e))) as Observable<any>;
  }

    getExtrato(id) {
      return this.http.get('rest/front/cobrancas/' + id + '/extrato-txt', { responseType: 'blob' }).pipe(
        catchError((e) => this.handleError(e))) as Observable<any>;
    }

  // nao tem no BaseEntityService pra fazer override
  getCobranca(id): any {
    return this.http.get('rest/front/cobrancas/' + id).pipe(
      catchError((e) => this.handleError(e))) as Observable<Cobranca>;
  }

  // nao tem no BaseEntityService pra fazer override
  getCobrancas(params?: any): any {
    return this.http.get(`rest/front/cobrancas`, {params: params}).pipe(
      catchError((e) => this.handleError(e))) as Observable<Array<Cobranca>>;
  }

  // nao tem no BaseEntityService pra fazer override
  getRelatorioCobrancaECG(): any {
    return this.http.get('rest/front/cobrancas/relatorio-repasse-ecg').pipe(
      catchError((e) => this.handleError(e))) as Observable<any>;
  }

  reemitirCobranca(idCobranca: number, motivoReemissao: string): Observable<any> {
    const options: any = blockUi();
    options.headers = new HttpHeaders().set('Content-Type', 'application/json');

    return this.http.post(`rest/front/cobrancas/${idCobranca}/reemitir`, motivoReemissao, options).pipe(
      catchError((e) => this.handleError(e))) as Observable<any>;
  }
}
